/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import globals from '../globals/globals';

var getRootContext = function getRootContext() {
  if (globals().localServerMode) {
    return globals().rootContextPath + '/api';
  } else {
    return globals().rootContextPath || '/';
  }
};

var getUnitTestRootContext = function getUnitTestRootContext() {
  return '/context';
};

export default (function () {
  return window.mwfGlobals._unitTests ? getUnitTestRootContext() : getRootContext();
});